<template>
    <div v-if="client">
        <!-- skip links screen -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Skip links screen</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.viewSettings.sweepstakes.skipLinksScreen"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- use sweepstakes profile screen -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Use sweepstakes profile screen</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.viewSettings.sweepstakes.useSweepstakesProfileScreen"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- ingame menu links -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Ingame menu links</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <content-link-ref
                            v-if="client.settings.viewSettings.sweepstakes.ingameMenuLinks"
                            :content-ref="client.settings.viewSettings.sweepstakes.ingameMenuLinks"
                            :delete-func="() => client.settings.viewSettings.sweepstakes.ingameMenuLinks = null"
                        />
                        <content-link-selector
                            v-else
                            :clientId="clientId"
                            :add-func="(contentRef) => client.settings.viewSettings.sweepstakes.ingameMenuLinks = contentRef"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';

import ContentLinkRef from '../../../../common/content/link/content-link-ref.vue';
import ContentLinkSelector from '../../../../common/content/link/content-link-selector.vue';

export default {
    name: 'client-settings-view-sweepstakes',
    components: { ContentLinkRef, ContentLinkSelector },
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
            this.loadClient();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/sweepstakes.vue